<template>
  <div v-if="quoform.cpastureinfo!=''">
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix"><b><i class="el-icon-s-finance"></i>订单确认</b></div>
      <div class=' contijiao wkbmf loaded' v-if="quoform.cvencheck=='已确认'">
        <div class='stamp stamp1'> </div>
      </div>
      <div class="text item text-center" style="width:100%;height:60px;">
        <div class="pull-right" style="margin-bottom: 15px">
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" plain size="medium" @click.native="GetInquiryListInfo('')">全部要货详情</el-button>
          </Debounce>
          <el-button type="primary" plain size="medium" @click="PriceSubmit"
            :disabled="quoform.cvencheck=='已确认'">确认</el-button>
          <el-button type="info" plain size="medium" @click="printpage()">订单打印</el-button>
          <el-upload style="display:inline-block;margin:0 10px" action="#" v-if="quoform.cmastupfile=='是'"
            :disabled="quoform.cvencheck=='已确认'" ref="uploadFail" :show-file-list="false"
            :before-upload="brforeUploadreImportFail" :auto-upload="false" :on-change="handleChangeFail"
            :file-list="fileListFail" :accept="typeaccept">
            <el-button type="success" size="medium" plain
              :disabled="quoform.cvencheck=='已确认'">回执单上传({{typeaccept}})</el-button>
          </el-upload>
          <el-button type="warning" plain @click.native="GetHTFileUrl()" v-if="quoform.cmastupfile=='是'"
            size="medium">预览</el-button>
          <!-- <el-button type="info" plain size="medium" @click="returnpage">返回</el-button> -->
          <el-button type="info" plain size="medium" @click="returnpage('1')">返回主表</el-button>
          <el-button type="info" plain size="medium" @click="returnpage('2')">返回首页</el-button>
        </div>
      </div>
      <!--  -->
      <div style="width:100%">
        <el-form :inline="true" :model="quoform" class="demo-form-inline itemwidth infodata" label-width="100px">
          <el-form-item label="订单号">
            <el-input v-model="quoform.csapcode" placeholder="订单号" disabled></el-input>
          </el-form-item>
          <el-form-item label="公司信息" class="cremark">
            <el-input v-model="quoform.cpastureinfo" placeholder="公司信息" disabled></el-input>
          </el-form-item>
          <el-form-item label="订单日期">
            <el-input v-model="quoform.dpurtime" placeholder="订单日期" disabled></el-input>
          </el-form-item>
          <el-form-item label="截止日期">
            <el-input v-model="quoform.dvencheckend" placeholder="截止日期" disabled></el-input>
          </el-form-item>
          <!-- <el-form-item label="厂商">
            <el-input v-model="quoform.cvenname" placeholder="厂商" disabled></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="订单类型">
            <el-input v-model="quoform.cordertype" placeholder="订单类型" disabled></el-input>
          </el-form-item> -->

          <el-form-item label="紧急程度">
            <el-input v-model="quoform.curgent" placeholder="紧急程度" disabled></el-input>
          </el-form-item>
          <el-form-item label="备注" class="cremark">
            <el-input v-model="quoform.cremark" placeholder="备注" disabled></el-input>
          </el-form-item>
          <el-form-item label="是否盖章回执">
            <el-input v-model="quoform.cisreceipt" placeholder="是否盖章回执" disabled></el-input>
          </el-form-item>
          <el-form-item label="采购员">
            <el-input v-model="quoform.cmaker" placeholder="采购员" disabled></el-input>
          </el-form-item>
          <el-form-item label="送达方" class="cremark">
            <el-input v-model="quoform.cdeliveryname" placeholder="送达方" disabled></el-input>
          </el-form-item>

        </el-form>
      </div>

    </el-card>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix"><b><i class="el-icon-s-finance"></i>订单信息</b>
        <font class="ming">具体要货日期请查看要货详情</font>
      </div>
      <el-table :data="tableData" style="width: 100%; background: transparent" max-height="420"
        class="tb-edit tablecenter" show-summary :summary-method="getSummaries" border highlight-current-row
        :header-cell-style="{ background: '#eef1f6'}" :row-class-name="tableRowClassName">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <!-- <el-table-column label="SRM物料编码" prop="csrminvcode" min-width="100px" /> -->
        <el-table-column label="物料编码" prop="csapinvcode" width="100px" />
        <el-table-column label="名称" prop="cinvname" min-width="120px" />
        <el-table-column label="规格" prop="cspecification" width="60px" />
        <el-table-column label="计量单位" prop="cunit" width="110px" />
        <el-table-column label="订单数量" prop="iordernumber" width="80px" />
        <!-- <el-table-column label="送货仓库" prop="cjhname" min-width="120px" /> -->
        <!-- <el-table-column label="到场日期" prop="dfactorydate" width="110px" /> -->

        <el-table-column label="含税单价" prop="itaxeprice" width="90px" />
        <el-table-column label="税率" prop="itaxe" width="60px" />
        <el-table-column label="含税金额" prop="ihsmoney" width="100px" />
        <el-table-column label="送货仓库" prop="cjhname" width="100px" />
        <el-table-column label="图纸版本号" prop="cversioncode_inv" width="100px" />
        <el-table-column label="图纸版本描述" prop="cdescribe_inv" width="100px" />
        <el-table-column label="是否版本变更" prop="cversionup" v-if="bbbg" />
        <el-table-column label="备注" prop="cremark_inv" min-width="120px" />
        <!-- <el-table-column label="不含税单价" prop="inotaxeprice" width="100px" />
         -->
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="GetInquiryListInfo(scope.row)">要货详情</el-button>
            <el-button size="mini" type="primary" plain @click="GetDrawingInfo(scope.row)"
              v-if="scope.row.cisversion=='是'">查看图纸</el-button>
          </template>

        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog title="要货详情" :visible.sync="dialogFormVisible" customClass="way sadform" :append-to-body="true">
      <div class="text item text-center" style="width:100%;height:60px;">
        <div class="pull-right" style="margin-bottom: 15px">
          <el-button type="primary" size="medium" @click="exportExcel()">导出</el-button>
        </div>
      </div>
      <el-table :data="tablequiry" style="width: 100%; background: transparent" border class="tb-edit"
        highlight-current-row id="out-table" :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="50"></el-table-column>cliststatus
        <el-table-column label="物料名称" prop="cinvname_list" min-width="100px" />
        <el-table-column label="规格" prop="cinvstd" width="60px" />
        <el-table-column label="计量单位" prop="cinvunit" width="90px" />
        <el-table-column label="要求到货日期" prop="ddhdate" width="110px" />
        <!-- <el-table-column label="已送货" prop="irkqty" width="110px" />
        <el-table-column label="送货数量" prop="inum" width="80px" />
        <el-table-column label="是否生效" prop="cliststatus" width="80px" /> -->
        <el-table-column label="订单数量" prop="inum" width="80px" />
        <el-table-column label="要货车次" prop="iplancarnum" width="80px" />
        <!-- 暂无字段 -->
        <el-table-column label="备注" prop="cremarklist " width="160px" />
      </el-table>
      <!-- </el-form> -->
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="dialogFormVisible=false">确 定</el-button>
      </div>
    </el-dialog>
    <div class="text item text-center" id="export" style="display:none;">
      <div v-if="main.length!=0" class="divbody">
        <h3 class="text-center">{{main[0].ctitel}}</h3>
        <table cellpadding="0" cellspacing="0" class="tableshd">

          <tbody>
            <tr>
              <td style="width:120px;text-align:left" colspan="2">订单编号</td>
              <td style="text-align:left" colspan="3">{{main[0].code}}</td>
              <td style="width:120px;text-align:left" colspan="2">订单日期</td>
              <td style="text-align:left" colspan="5">{{main[0].ddate}}</td>
            </tr>
            <tr>
              <td style="width:120px;text-align:left" colspan="2">供应商名称</td>
              <td style="text-align:left" colspan="3">{{main[0].cvenname}}</td>
              <td style="width:120px;text-align:left" colspan="2">供应商编号</td>
              <td style="text-align:left" colspan="5">{{main[0].cvencode}}</td>
            </tr>
            <tr>
              <td style="width:120px;text-align:left" colspan="2">发件人</td>
              <td style="text-align:left" colspan="3">{{main[0].cmaker}}</td>
              <td style="width:120px;text-align:left" colspan="2">收件人</td>
              <td style="text-align:left" colspan="5">{{main[0].cvenoper}}</td>
            </tr>
            <tr>
              <td style="width:120px;text-align:left" colspan="2">发件人联系方式</td>
              <td style="text-align:left" colspan="3">{{main[0].cftel}}</td>
              <td style="width:120px;text-align:left" colspan="2">收件人联系方式</td>
              <td style="text-align:left" colspan="5">{{main[0].cstel}}</td>
            </tr>
            <tr>
              <td style="width:120px;text-align:left" colspan="2">发件人邮箱</td>
              <td style="text-align:left" colspan="3">{{main[0].cfemail}}</td>
              <td style="width:120px;text-align:left" colspan="2">收件人邮箱</td>
              <td style="text-align:left" colspan="5">{{main[0].csemail}}</td>
            </tr>

            <tr>
              <td style="width:2%" nowrap>行项目</td>
              <td nowrap>物料编码</td>
              <td nowrap>物料描述</td>
              <td style="width:4%" nowrap>单位</td>
              <td style="width:4%" nowrap>不含税单价</td>
              <td style="width:4%" nowrap>含税单价</td>
              <td style="width:4%" nowrap>订购数量</td>
              <td style="width:4%" nowrap>含税金额</td>
              <td style="width:100px" nowrap>到货日期</td>
              <td nowrap style="width:4%">到货仓库</td>
              <td nowrap colspan="2" style="width:8%">备注</td>
            </tr>

            <tr v-for="(mainlist,i) in met" :key="i">
              <td>{{mainlist.csaphang}}</td>
              <td>{{mainlist.cinvcode}}</td>
              <td>{{mainlist.cinvname}}</td>
              <td>{{mainlist.cunit}}</td>
              <td>{{mainlist.inotaxeprice}}</td>
              <td>{{mainlist.itaxeprice}}</td>
              <td>{{mainlist.iordernumber}}</td>
              <td>{{mainlist.itax}}</td>
              <td>{{mainlist.dfactorydate}}</td>
              <td>{{mainlist.cjhname}}</td>
              <td colspan="2"></td>
            </tr>

            <tr>
              <td colspan="7" style="text-align:left;">合计金额</td>
              <td colspan="5" style="text-align:left;">{{zongji}}</td>
            </tr>
            <tr>
              <td colspan="12" style="height:60px;text-align:left;">备注：</td>
            </tr>
            <tr>
              <td colspan="12" style="text-align:left;">说明：<br>
                1.收到订单后请签字盖章确认并在24小时之内回传到我公司发件人，如有问题，请以书面形式回复至发件人，否则视为默认。<br>
                2.发货时必须将物料的产品经验报告单，送货单随货同行。<br>
                3.物料包装、标签及产品检验报告单内容必须符合我公司质量技术标准要求。<br>
                4.如因以上验证项判定产品不合格，我公司有权退货，因此造成影响我公司正常生产，将对贵公司被情节进行处罚，请配合，谢谢！<br>
                5.请与我方对账无误后开票，开票时间要求26号之前开出发票并交我方采购人员处。</td>
            </tr>
            <tr>
              <td colspan="5">供应商确认栏</td>
              <td colspan="7">增值税开票明细</td>
            </tr>
            <tr>
              <td colspan="5" style="text-align:left;vertical-align: bottom;">
                供应商（签字/盖章）：
              </td>
              <td colspan="7" style="text-align:left"><span>单位名称:</span>{{main[0].cpastureinfo}}<br>
                <span>地址：</span>{{main[0].caddress}}<br><br><br>
                <span>电话:</span>{{main[0].ccorptel}}<br>
                <span>账号：</span>{{main[0].caccount}}<br>
                <span>税号：</span>{{main[0].ctaxnumber}}<br>
                <span>开户行：</span>{{main[0].cbankname}}
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align:left">
                特殊说明：
              </td>
              <td colspan="9" style="text-align:left">

              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<style>
  .el-table .success-row {
    background: #59ff00;
  }
</style>
<script>
  import FileSaver from "file-saver";
  import XLSX from "xlsx";
  import { printExcel } from "../../../../utils/config";
  import { RemovePruchaseToDo, GetFileType } from "../../../../api/home";
  export default {
    data() {
      return {
        quoform: {
          csapcode: "",
          cpastureinfo: "",
          dpurtime: "",
          dvencheckend: "",
          curgent: "",
          cisreceipt: "",
          cmaker: "",
        },
        tableData: [],
        tablequiry: [],
        suprow: {},
        fileListFail: [],
        dialogFormVisible: false,
        typeaccept: "",
        met: [],
        main: [],
        zongji: 0,
        bbbg: false,
        previnformdata: {},
      };
    },
    created() {
      if (this.$route.params.rows) {
        this.suprow = this.$route.params.rows;
        sessionStorage.setItem("suprow", JSON.stringify(this.$route.params.rows));
        this.previnformdata = this.$route.params.informdata;
        sessionStorage.setItem(
          "informdata",
          JSON.stringify(this.$route.params.informdata)
        );
      } else {
        this.suprow = JSON.parse(sessionStorage.getItem("suprow"));
        this.previnformdata = JSON.parse(sessionStorage.getItem("informdata"));
      }
      if (this.suprow.id) {
        console.log(this.suprow);
        this.GitPurchaseorderInfo();
        this.FileType();
      }
    },
    methods: {
      GetDrawingInfo(row) {
        console.log(row);
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetDrawingInfo",
          data: { iautoid: row.op_purchaseorder_inv_autoid },
        }).then((res) => {
          console.log(res, "获取信息结果");
          this.loading = false;
          if (res.data.Success) {
            if (res.data.Data[0].cdra_pdfurl != "") {
              window.open(this.global.BASE_URL + res.data.Data[0].cdra_pdfurl);
            } else {
              this.$message.error("暂无图文信息！");
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      //打印
      printpage() {
        this.zongji = 0;
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetOrderTemplateInfo",
          data: { KeyValue: this.suprow.id },
        }).then((res) => {
          console.log(res, "获取信息结果");
          this.loading = false;
          if (res.data.Success) {
            if (res.data.Data.det) {
              this.met = res.data.Data.det;
              if (this.met.length < 8) {
                var dleng = 8 - this.met.length;
                var newdata = {
                  op_purchaseorder_inv_id: "",
                  cinvcode: "",
                  csapinvcode: "",
                  cinvname: "",
                  cunit: "",
                  inotaxeprice: "",
                  itaxeprice: "",
                  iordernumber: "",
                  itax: "",
                  dfactorydate: "",
                  cjhcode: "",
                  cjhname: "",
                };
                for (var a = 0; a < dleng; a++) {
                  this.met.push(newdata);
                }
              }
              for (a = 0; a < this.met.length; a++) {
                if (this.met[a].itax == "") {
                  this.zongji += 0;
                } else {
                  this.zongji += parseInt(this.met[a].itax);
                }
              }

              setTimeout(() => {
                printExcel("export");
              }, 200);
            }
            if (res.data.Data.main) {
              this.main = res.data.Data.main;
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 求和
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "小计";
            return;
          }
          if (index === 1) {
            sums[index] = "";
            return;
          }
          const values = data.map((item) => Number(item[column.property]));

          if (index == 5 || index == 8) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "N/A";
            }
          }
        });

        return sums;
      },
      //定义导出Excel表格事件
      exportExcel() {
        /* 从表生成工作簿对象 */
        var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"), {
          raw: true,
        });
        /* 获取二进制字符串作为输出 */
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });
        try {
          FileSaver.saveAs(
            //Blob 对象表示一个不可变、原始数据的类文件对象。
            //Blob 表示的不一定是JavaScript原生格式的数据。
            //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
            //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
            new Blob([wbout], { type: "application/octet-stream" }),
            //设置导出文件名称
            "订单确认.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
      },
      // 获取文件类型
      FileType() {
        GetFileType({ type: "05" }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.typeaccept = res.data.Data[0].cfileformat;
          }
        });
      },
      // 预览
      GetHTFileUrl() {
        console.log(this.quoform.cupfilepath);
        if (
          this.quoform.cupfilepath != "" &&
          this.quoform.cupfilepath != undefined
        ) {
          window.open(this.global.bxiorder + this.quoform.cupfilepath);
        } else {
          this.$message.error("暂无文件！");
        }
      },

      // 获取信息
      GitPurchaseorderInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GitPurchaseorderInfo",
          data: { KeyValue: this.suprow.id },
        }).then((res) => {
          console.log(res, "获取信息结果");
          this.loading = false;
          if (res.data.Success) {
            this.quoform = res.data.Data.dt[0];
            this.tableData = res.data.Data.dt2;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 获取信息

      GetInquiryListInfo(row) {
        var csrimcode;
        if (row.csrminvcode) {
          csrimcode = row.csrminvcode;
        } else {
          csrimcode = "";
        }

        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetInquiryListInfo",
          data: {
            KeyValue: this.suprow.id,
            csrminvcode: csrimcode,
          },
        }).then((res) => {
          console.log(res, "获取信息结果");
          this.loading = false;
          if (res.data.Success) {
            this.tablequiry = res.data.Data;
            this.dialogFormVisible = true;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      //  确认
      PriceSubmit() {
        this.$confirm("点击确认之后将无法在上传文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios({
              method: "post",
              url: "CommonModule/Op_Supplier/QueryPurchaseorder",
              data: { KeyValue: this.suprow.id },
            }).then((res) => {
              console.log(res, "确认");
              if (res.data.Success) {
                this.$message.success("确认成功！");
                this.removerp();
                this.returnpage("1");
              } else {
                this.$message.error(res.data.Message);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      },
      // 删除待办事项中的信息
      removerp() {
        RemovePruchaseToDo({
          KeyValue: this.suprow.id,
        }).then((res) => {
          console.log(res);
        });
      },
      // 返回
      returnpage(type) {
        sessionStorage.removeItem("params");
        if (type == "1") {
          this.$router.push({
            path: "/OrderConfirmList/OrderConfirmList",
            query: { informdata: this.previnformdata },
          });
        } else {
          this.$router.push({ path: "/home" });
        }
      },

      //上传文件
      handleChangeFail(file, fileList) {
        this.$refs.uploadFail.submit();
      },
      // 上传文件
      brforeUploadreImportFail(file) {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SupplierCheckAll",
          data: { cbilltype: "订单上传", cbillid: this.suprow.id },
        }).then((res) => {
          console.log(res, "上传结果果上传结果");
          if (res.data.Success) {
            let varparams = new FormData();
            varparams.append("file", file);
            varparams.append("file", URL.createObjectURL(file));
            varparams.append("cvoucherno", "op_purchaseorder");
            varparams.append("ctype", "05");
            varparams.append("cvoucherid", this.suprow.id);
            this.$axios({
              method: "post",
              url: "CommonModule/Op_Supplier/BaseUploadFile",
              headers: { "Content-Type": "multipart/form-data" },
              data: varparams,
              timeout: 30000000,
            }).then((res) => {
              console.log(res, "上传结果");

              if (res.data.Success) {
                this.$message({
                  howClose: true,
                  message: "上传成功",
                  type: "success",
                });

                this.quoform.cupfilepath = res.data.Data.Path;
              } else {
                this.$message.error(res.data.Message);
              }
            });

            return false; //屏蔽了action的默认上传
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      //是否版本变更，是变换行颜色
      tableRowClassName({ row }) {
        console.log(row, "获取信息结果");
        if (row.cversionup == "是") {
          return "success-row";
        }
        return "";
      },
    },
  };
</script>
<style scoped>
  .itemwidth .el-input {
    width: 160px;
  }

  .itemwidth .el-select {
    width: 160px;
  }

  .cremark .el-input {
    width: 430px;
  }
</style>